import * as Yup from "yup";
const addDocumentsValidation = Yup.object().shape({
  orderId: Yup.string().required("Order Id is required"),
  transitDocuments: Yup.array()
    .required("Document(s) are required!")
    .min(1, "Document(s) are required!"),
});

export default addDocumentsValidation;
